module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row row-wider"
  }, [(_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearch),
      expression: "isSearch"
    }],
    staticClass: "col-md-12",
    attrs: {
      "id": "divUserAdminSearch"
    }
  }, [_c('div', [_c('h4', [_vm._v("New Users (Setup Required)")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserSearchDto.username),
      expression: "newUserSearchDto.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchUsername"
    },
    domProps: {
      "value": (_vm.newUserSearchDto.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserSearchDto, "username", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserSearchDto.firstName),
      expression: "newUserSearchDto.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchFirstName"
    },
    domProps: {
      "value": (_vm.newUserSearchDto.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserSearchDto, "firstName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserSearchDto.lastName),
      expression: "newUserSearchDto.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchLastName"
    },
    domProps: {
      "value": (_vm.newUserSearchDto.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserSearchDto, "lastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "button"
    },
    on: {
      "click": _vm.searchNewUser
    }
  }, [_vm._v("Search")])])])]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.newUserList,
      "columns": _vm.userGridSpec.columnsNew,
      "options": _vm.userGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.editUser(props.row)
            }
          }
        })])]
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deleteUser(props.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', [_c('h4', [_vm._v("All Users")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allUserSearchDto.username),
      expression: "allUserSearchDto.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchUsername"
    },
    domProps: {
      "value": (_vm.allUserSearchDto.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.allUserSearchDto, "username", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allUserSearchDto.firstName),
      expression: "allUserSearchDto.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchFirstName"
    },
    domProps: {
      "value": (_vm.allUserSearchDto.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.allUserSearchDto, "firstName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allUserSearchDto.lastName),
      expression: "allUserSearchDto.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchLastName"
    },
    domProps: {
      "value": (_vm.allUserSearchDto.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.allUserSearchDto, "lastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "button"
    },
    on: {
      "click": _vm.searchUser
    }
  }, [_vm._v("Search")])])])]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.userGridSpec.tableData,
      "columns": _vm.userGridSpec.columns,
      "options": _vm.userGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.editUser(props.row)
            }
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSearch),
      expression: "!isSearch"
    }],
    staticClass: "col-md-12",
    attrs: {
      "id": "divUserAdminEdit"
    }
  }, [_c('h4', [_vm._v("Edit User")]), _vm._v(" "), _c('form', {
    ref: "editForm",
    staticClass: "form form-horizontal",
    attrs: {
      "data-vv-scope": "editUser"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Username/Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Auth0 Method")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.user.auth0Method))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("First Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("User Organizations")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.user.userOrganization), function(item, index) {
    return _c('tr', {
      key: item.userOrganizationId
    }, [_c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.isPrimary ? "Yes" : "No"))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "fa fa-ban",
      staticStyle: {
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          _vm.removeOrganization(index)
        }
      }
    })])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-1 col-md-offset-3"
  }, [_c('button', {
    staticClass: "form-contol btn",
    on: {
      "click": function($event) {
        _vm.$refs['organizationModal'].open()
      }
    }
  }, [_vm._v("Add Organization")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("User Roles")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, _vm._l((_vm.roleList), function(role) {
    return _c('div', {
      key: role.roleId,
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.roleSelectedList),
        expression: "roleSelectedList"
      }],
      attrs: {
        "type": "checkbox",
        "id": role.roleId
      },
      domProps: {
        "value": role.roleId,
        "checked": Array.isArray(_vm.roleSelectedList) ? _vm._i(_vm.roleSelectedList, role.roleId) > -1 : (_vm.roleSelectedList)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.roleSelectedList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = role.roleId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.roleSelectedList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.roleSelectedList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.roleSelectedList = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": role.roleId
      }
    }, [_vm._v(_vm._s(role.description))])])
  }))]), _vm._v(" "), _c('modal', {
    ref: "organizationModal"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Add User Organization")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['organizationModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Organization")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userOrganizationDto.organizationId),
      expression: "userOrganizationDto.organizationId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.userOrganizationDto, "organizationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select An Organization")]), _vm._v(" "), _vm._l((_vm.organizationList), function(org) {
    return _c('option', {
      key: org.organizationId,
      domProps: {
        "value": org.organizationId
      }
    }, [_vm._v(_vm._s(org.description))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Is Primary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userOrganizationDto.isPrimary),
      expression: "userOrganizationDto.isPrimary"
    }],
    attrs: {
      "id": "orgIsPrimaryCB",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.userOrganizationDto.isPrimary) ? _vm._i(_vm.userOrganizationDto.isPrimary, null) > -1 : (_vm.userOrganizationDto.isPrimary)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.userOrganizationDto.isPrimary,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.userOrganizationDto.isPrimary = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.userOrganizationDto.isPrimary = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.userOrganizationDto, "isPrimary", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "orgIsPrimaryCB"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "disabled": _vm.userOrganizationDto.organizationId == null,
      "name": "buttonDone"
    },
    on: {
      "click": function($event) {
        _vm.addOrganization()
      }
    }
  }, [_vm._v("Add")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-left",
    on: {
      "click": _vm.backToSearch
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-left",
    on: {
      "click": _vm.saveUser
    }
  }, [_vm._v("Save")])])])], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("User Administration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "searchUsername"
    }
  }, [_vm._v("Username/Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "searchFirstName"
    }
  }, [_vm._v("First Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "searchLastName"
    }
  }, [_vm._v("Last Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr', {
    staticClass: "spacer "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "searchUsername"
    }
  }, [_vm._v("Username/Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "searchFirstName"
    }
  }, [_vm._v("First Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "searchLastName"
    }
  }, [_vm._v("Last Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Organization Name")]), _vm._v(" "), _c('th', [_vm._v("Primary")]), _vm._v(" "), _c('th', [_vm._v("Remove")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fca49a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserAdministration.vue
// module id = 896
// module chunks = 1